export default "__VITE_ASSET__Fbv8uaMx__"